import { render, staticRenderFns } from "./HotelPriceDetails.vue?vue&type=template&id=58bd4483"
import script from "./HotelPriceDetails.vue?vue&type=script&lang=js"
export * from "./HotelPriceDetails.vue?vue&type=script&lang=js"
import style0 from "./HotelPriceDetails.vue?vue&type=style&index=0&id=58bd4483&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports